<template>
  <m-grid-list-item
    class="bg-gray-300 uppercase text-sm font-semibold tracking-wide text-gray-600 items-center"
  >
    <div class="py-3 col-start-2">Account</div>
    <div class="py-3">Balance</div>
    <div class="py-3 hidden lg:block lg:break-words lg:leading-tight">Tax Free<br />Component</div>
    <div class="py-3">Status</div>
  </m-grid-list-item>
</template>

<script>
export default {
  name: 'accounts-header',
};
</script>

<style>

</style>
